export type SiteLocale = "en" | "pt" | "es";
export type GuideAlternateLocale = "en" | "pt-BR" | "es";
export type GuideAlternatePaths = Record<GuideAlternateLocale, string>;

export const guideAlternatePaths = {
  "/how-to-see-who-someone-followed-on-instagram/": {
    en: "/how-to-see-who-someone-followed-on-instagram/",
    "pt-BR": "/pt/como-ver-quem-alguem-seguiu-no-instagram/",
    es: "/es/como-ver-a-quien-alguien-siguio-en-instagram/",
  },
  "/instagram-follow-tracker/": {
    en: "/instagram-follow-tracker/",
    "pt-BR": "/pt/rastreador-de-seguidores-instagram/",
    es: "/es/rastreador-de-seguidores-instagram/",
  },
  "/track-instagram-following-activity/": {
    en: "/track-instagram-following-activity/",
    "pt-BR": "/pt/rastrear-atividade-de-seguidos-instagram/",
    es: "/es/rastrear-actividad-de-seguidos-instagram/",
  },
  "/anonymous-instagram-tracker/": {
    en: "/anonymous-instagram-tracker/",
    "pt-BR": "/pt/rastreador-anonimo-instagram/",
    es: "/es/rastreador-anonimo-instagram/",
  },
  "/instagram-follow-notifications/": {
    en: "/instagram-follow-notifications/",
    "pt-BR": "/pt/notificacoes-de-novos-seguidos-instagram/",
    es: "/es/notificaciones-nuevos-seguidos-instagram/",
  },
  "/instagram-unfollow-tracker/": {
    en: "/instagram-unfollow-tracker/",
    "pt-BR": "/pt/rastreador-de-unfollows-instagram/",
    es: "/es/rastreador-de-unfollows-instagram/",
  },
  "/instagram-following-list-changes/": {
    en: "/instagram-following-list-changes/",
    "pt-BR": "/pt/mudancas-na-lista-de-seguidos-instagram/",
    es: "/es/cambios-en-la-lista-de-seguidos-instagram/",
  },
} as const satisfies Record<
  string,
  Record<GuideAlternateLocale, string>
>;

export function getGuideAlternates(path: string) {
  return (
    (Object.values(guideAlternatePaths) as GuideAlternatePaths[]).find(
      (paths) => Object.values(paths).includes(path),
    ) ?? null
  );
}

export function getLocalizedGuidePath(
  path: string,
  locale: SiteLocale,
): string | null {
  const alternates = getGuideAlternates(path);
  if (!alternates) return null;

  const guideLocale: GuideAlternateLocale =
    locale === "pt" ? "pt-BR" : locale;
  return alternates[guideLocale];
}

export const landingPaths: Record<SiteLocale, string> = {
  en: "/",
  pt: "/pt/",
  es: "/es/",
};

export function getLandingLocale(path: string): SiteLocale | null {
  if (path === "/" || path === "") return "en";
  if (path === "/pt" || path === "/pt/") return "pt";
  if (path === "/es" || path === "/es/") return "es";
  return null;
}

export function getLocalizedPath(path: string, locale: SiteLocale): string {
  const landingLocale = getLandingLocale(path);
  if (landingLocale) return landingPaths[locale];

  return getLocalizedGuidePath(path, locale) ?? path;
}
